module.exports = __webpack_public_path__ + "static/media/wilab.9614367d.jpg";